export default () => {
    if (!import.meta.env.VITE_ZENDESK_KEY) {
        return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'ze-snippet';
    script.async = true;
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${import.meta.env.VITE_ZENDESK_KEY}`;
    document.getElementsByTagName('head')[0].appendChild(script);
};
